import { Button, Card, CardContent, Input } from '@features/ui';
import { DuplicateIcon } from '@features/ui/icons';
import { useGetMe } from '@src/hooks/useGetMe';
import { joinAffiliateProgram } from '@src/services/affiliate';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

interface MarketingMaterial {
  name: string;
  description: string;
  url: string;
}

const marketingMaterials: MarketingMaterial[] = [
  {
    name: 'Leeloo Blue Vertical 1.png',
    description: 'Leeloo Blue Vertical 1',
    url: '/assets/Leeloo Blue Vertical 1.png',
  },
  {
    name: 'Leeloo Pur Vertical 2.png',
    description: 'Leeloo Blue Vertical 2',
    url: '/assets/Leeloo Pur Vertical 2.png',
  },
  {
    name: 'Leeloo Blue Horizontal 1.png',
    description: 'Leeloo Blue Horizontal',
    url: '/assets/Leeloo Blue Horizontal 1.png',
  },
  {
    name: 'Spanish Vertical blue 1.png',
    description: 'Spanish Vertical Blue',
    url: '/assets/Spanish Vertical blue 1.png',
  },
  {
    name: 'Spanish Vertical Purple 1.png',
    description: 'Spanish Vertical Purple',
    url: '/assets/Spanish Vertical Purple 1.png',
  },
  {
    name: 'burst horizontal.png',
    description: 'Burst Horizontal',
    url: '/assets/burst horizontal.png',
  },
  {
    name: 'burst square.png',
    description: 'Burst Square',
    url: '/assets/burst square.png',
  },
  {
    name: 'climb horizontal.png',
    description: 'Climb Horizontal',
    url: '/assets/climb horizontal.png',
  },
  {
    name: 'climb square.png',
    description: 'climb square',
    url: '/assets/climb square.png',
  },
  {
    name: 'cruise horizontal.png',
    description: 'Cruise Horizontal',
    url: '/assets/cruise horizontal.png',
  },
  {
    name: 'cruise square.png',
    description: 'Cruise Square',
    url: '/assets/cruise square.png',
  },
  {
    name: 'explode horizontal.png',
    description: 'Explode Horizontal',
    url: '/assets/explode horizontal.png',
  },
  {
    name: 'explode square.png',
    description: 'Explode Square',
    url: '/assets/explode square.png',
  },
  {
    name: 'express horizontal.png',
    description: 'Express Horizontal',
    url: '/assets/express horizontal.png',
  },
  {
    name: 'express square.png',
    description: 'Express Square',
    url: '/assets/express square.png',
  },
  {
    name: 'glide horizontal.png',
    description: 'glide horizontal',
    url: '/assets/glide horizontal.png',
  },
  {
    name: 'glide square.png',
    description: 'glide square',
    url: '/assets/glide square.png',
  },
  {
    name: 'launch horizontal.png',
    description: 'launch horizontal',
    url: '/assets/launch horizontal.png',
  },
  {
    name: 'launch square.png',
    description: 'launch square',
    url: '/assets/launch square.png',
  },
  {
    name: 'launch square.png',
    description: 'launch square',
    url: '/assets/launch square.png',
  },
  {
    name: 'qualified square banner.png',
    description: 'qualified square banner',
    url: '/assets/qualified square banner.png',
  },
  {
    name: 'square slogan.png',
    description: 'square slogan',
    url: '/assets/square slogan.png',
  },
  {
    name: 'square slogan 2.png',
    description: 'square slogan 2',
    url: '/assets/square slogan 2.png',
  },
  {
    name: 'trade less live more horizontal.png',
    description: 'trade less live more horizontal',
    url: '/assets/trade less live more horizontal.png',
  },
  {
    name: 'vertical trade less live more.png',
    description: 'vertical trade less live more',
    url: '/assets/vertical trade less live more.png',
  },
  {
    name: 'Leeloo_970x550_1.jpg',
    description: 'Why Leeloo Static 1',
    url: '/assets/Leeloo_970x550_1.jpg',
  },
  {
    name: 'Leeloo_970x550_why_1_animated.gif',
    description: 'Why Leeloo Animated',
    url: '/assets/Leeloo_970x550_why_1_animated.gif',
  },
  {
    name: 'Leeloo_970x550_why_1_static.jpg',
    description: 'Why Leeloo Static 2',
    url: '/assets/Leeloo_970x550_why_1_static.jpg',
  },
  {
    name: 'Leeloo_970x550_why_2_static.jpg',
    description: 'Why Leeloo Static 3',
    url: '/assets/Leeloo_970x550_why_2_static.jpg',
  },
  {
    name: 'Leeloo_970x550_why_3_static.jpg',
    description: 'Why Leeloo Static 4',
    url: '/assets/Leeloo_970x550_why_3_static.jpg',
  },
];

export const AffiliatesBannerAndLinksPage = () => {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const { me } = useGetMe();

  const handleJoinAffiliate = async () => {
    try {
      await joinAffiliateProgram();

      toast.success('Successfully joined the affiliate program!');
    } catch (error: any) {
      console.error('Failed to join affiliate program:', error);
      toast.error('Failed to join affiliate program. Please try again.');
    }
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(me?.affiliate_landing_link || '');
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
      toast.error('Failed to copy link to clipboard');
    }
  };

  const handleDownload = async (url: string, filename: string) => {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = downloadUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  return (
    <div className="max-w-5xl">
      <Card className="bg-background-tertiary border-none p-0">
        <CardContent className="px-0">
          {/* Header */}
          <h1 className="text-2xl font-bold mb-6">Affiliate info</h1>

          {/* Registration Info */}
          <div className="mb-6 space-y-4">
            <p className="text-sm">
              To register to become a Leeloo Affiliate,{' '}
              <button
                className="text-primary hover:underline font-semibold bg-transparent border-none cursor-pointer p-0"
                onClick={handleJoinAffiliate}
              >
                CLICK HERE
              </button>{' '}
              <span>
                (if you are redirected to this page after clicking the link, you
                are already signed up as an affiliate - Thank you!)
              </span>
            </p>

            <p className="text-sm">
              The Leeloo Affiliate Program is our way of saying thank you for
              believing in us and for helping spread the word about Leeloo. It
              is also your way of helping fellow traders save money and show
              appreciation to our partners.
            </p>

            <p className="text-sm">
              As a Leeloo Affiliate, you are paid 10% for the six-month lifespan
              of each trader you send to Leeloo. It is all tracked for you with
              your Affiliate link or coupon code.
            </p>

            <p className="text-sm">
              We look forward to having you on our team!
            </p>
          </div>

          {/* Terms and Conditions */}
          <div className="bg-gray-700 p-4 rounded mb-6">
            <p className="text-lg">
              Please read our{' '}
              <span className="text-primary hover:underline">
                terms and conditions
              </span>{' '}
              before signing up.
            </p>
          </div>

          {/* Affiliate Link Section - Only show if user is affiliate member */}
          {me?.affiliate_landing_link && (
            <>
              <div className="mb-6">
                <h2 className="text-lg font-semibold mb-3">
                  Your General Affiliate Link
                </h2>
                <div className="flex gap-2">
                  <div className="flex-1 relative">
                    <Input
                      readOnly
                      className="bg-background-secondary border-border pr-10"
                      value={me?.affiliate_landing_link || ''}
                    />
                    <button
                      className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors"
                      title="Copy link"
                      onClick={handleCopyLink}
                    >
                      <DuplicateIcon className="w-5 h-5" />
                    </button>
                  </div>
                </div>
                {copied && (
                  <p className="text-sm text-primary mt-2">
                    Link copied to clipboard!
                  </p>
                )}
              </div>

              {/* Affiliate Account Links Button */}
              <div className="mb-8">
                <Button
                  className="border-primary text-primary hover:bg-primary/10"
                  variant="outline"
                  onClick={() => navigate('/affiliates/account-links')}
                >
                  Affiliate Account Links
                </Button>
              </div>
            </>
          )}

          {/* Marketing Materials Section */}
          <div>
            <h2 className="text-lg font-semibold mb-4">Marketing Materials</h2>
            <div className="space-y-2">
              {marketingMaterials.map((material, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between py-2 border-b border-border last:border-b-0"
                >
                  <div className="flex-1">
                    <button
                      className="text-primary hover:underline text-sm flex items-center gap-2 bg-transparent border-none cursor-pointer p-0"
                      onClick={() =>
                        handleDownload(material.url, material.name)
                      }
                    >
                      {material.name}
                    </button>
                    <p className="text-xs text-muted-foreground italic mt-0.5">
                      {material.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
